<template>
  <div>
    <div class="page_title">
      <custom-breadcrumb/>
    </div>
    <div class="page-header">
      <div class="search-box">
        <el-select
          v-model="query.order_status"
          clearable
          placeholder="Order status"
          @change="search"
        >
          <el-option
            v-for="item in orderStatusOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-input
          class="search_input"
          v-model="query.keywords"
          prefix-icon="el-icon-search"
          placeholder="Order# / Product Name / tracking# / SKU"
          clearable
        />
        <el-button type="primary" class="search-btn" @click="search"
        >Search
        </el-button>
      </div>
      <el-button class="search-btn" @click="toCreateOrder()">
        Create Order
      </el-button>
    </div>
    <div class="refer-content" v-loading="loading">
      <template v-if="dataList.length>0">
        <el-card class="order" shadow="never" v-for="(batch,batchIndex) in dataList" :key="batchIndex">
          <div slot="header" class="order-header">
            <div class="header-left">
              <div class="header-item">
                <div class="header-item-title">BatchOrder No.</div>
                <div class="header-item-con">{{ batch.batchNo }}</div>
              </div>
              <div class="header-item">
                <div class="header-item-title">Order Placed</div>
                <div class="header-item-con">{{ batch.time }}</div>
              </div>
              <div class="header-item">
                <div class="header-item-title">Total</div>
                <div class="header-item-con black-weight">{{ batch.payAmount }}</div>
              </div>
              <div class="header-item">
                <div class="header-item-title">Status</div>
                <div class="header-item-con black-weight">{{ batch.batchStatus }}</div>
              </div>
            </div>
            <el-button type="text" @click="handleDetail(batch.batchNo)" class="text-btn">View Details</el-button>
          </div>
          <div class="order-content" v-for="(order,orderIndex) in batch.orderInfoList" :key="orderIndex">
            <div class="con-title-1">
              <span class="title-item">Order# {{ order.orderId }}</span>
              <span class="title-item">
                  Total
                <span style="padding-left: 10px">${{ order.payAmount }}
              </span>
              </span>
              <span class="title-item">
                  Status
                <span
                  style="padding-left: 10px">
                  {{
                    $tool.valueToLabel(order.orderStatus, orderStatusOptions)
                  }}</span>
              </span>
            </div>
            <div class="con-title-2 black-weight">{{ order.brandName }}</div>
            <div class="con-images">
              <div v-for="(detail,imageIndex) in order.orderDetails" :key="imageIndex">
                <el-image :src="detail.skuImg" fit="fill"
                          class="img-item"
                          v-if="imageIndex<5"/>
                <el-image :src="detail.skuImg" fit="fill"
                          class="img-item"
                          v-if="order.showAll && imageIndex>=5"/>
              </div>
              <div v-if="order.orderDetails.length>5 && !order.showAll" class="more-btn">
                <span>{{ `+${order.orderDetails.length - 5}` }}</span>
                <el-button type="text" icon="el-icon-arrow-right" style="color: #3E3E3E;font-size: 20px"
                           @click="order.showAll = true"></el-button>
              </div>
              <el-button type="text" icon="el-icon-arrow-left" style="color: #3E3E3E;font-size: 20px"
                         @click="order.showAll = false" v-if="order.showAll" class="more-btn"></el-button>
            </div>
            <div style="margin-top: -34px">
              <span class="black-weight">Memo:</span>
              <span v-if="order.memo && order.readMore">{{ order.memo }}</span>
              <span v-if="order.memo && order.memo.length>80">{{ order.memo.substring(0, 80) + '...' }}</span>
              <el-button v-if="order.memo && order.memo.length>80 && !order.readMore" type="text"
                         style="color: #3E3E3E;margin-left: 20px;height: 20px"
                         @click="order.readMore = !order.readMore"
                         class="text-btn"> Read More
              </el-button>
              <el-button v-if="order.readMore" type="text"
                         style="color: #3E3E3E;margin-left: 20px;height: 20px"
                         @click="order.readMore = !order.readMore"
                         class="text-btn">Hidden
              </el-button>
            </div>
          </div>
        </el-card>
      </template>

      <div style="color: #999999" v-if="!loading && this.dataList.length===0">No data</div>
    </div>
    <div class="page_table" v-if="dataList.length>0">
      <Pagination
        :currentPage="query.current_page"
        :total="total"
        :pageSize="query.page_size"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      ></Pagination>
    </div>
  </div>
</template>

<script>
import {getAction} from '@/api/manage.js'
import Pagination from '../components/pagination.vue'
import CustomBreadcrumb from '../components/custom-breadcrumb'

export default {
  components: {Pagination, CustomBreadcrumb},
  data() {
    return {
      loading: false,
      supplierId: this.$ls.get('userInfo').id,
      orderStatusOptions: [
        {label: 'Unpaid', value: 0},
        {label: 'Paid', value: 1},
        {label: 'Cancelled', value: 2},
        {label: 'Shipped', value: 3},
        {label: 'Partial Shipped', value: 4},
        {label: 'Received', value: 5},
        {label: 'Refund under review', value: 6},
        {label: 'Refunded', value: 7},
        {label: 'Declined on Refund', value: 8},
        {label: 'On Hold', value: 31},
        {label: 'Progressing', value: 10},
        {label: 'Partial refund', value: 9},
        {label: 'Failed', value: 11},
        {label: 'Returning', value: 13},
        {label: 'Return completed', value: 23},
        {label: 'Complete partially', value: 24},
        {label: 'Tranding closed', value: 99},
        {label: 'Packaging', value: 40},
        {label: 'Partial Delivered', value: 52},
        {label: 'Delivered', value: 53},
        {label: 'Partial Received', value: 54}
      ],
      total: 0,
      query: {
        order_status: '',
        current_page: 1,
        page_size: 15,
        keywords: ''
      },
      dataList: []
    }
  },
  created() {
    getAction('/sp/suppliers/categorys').then(res => {
      if (res.code === 200) {
        this.categoryList = res.result
      }
    })
    this.loadData()
  },
  methods: {
    toCreateOrder() {
      // 批发商和供应商去不同的页面
      const userInfo = this.$ls.get('userInfo')
      if (userInfo.userSource === 2) {
        this.$router.push({path: 'create-refer-orders'})
      } else {
        this.$router.push({path: 'wholesale-create-refer-orders'})
      }
    },
    loadData() {
      this.loading = true
      getAction(`/order/api/v0.2/suppliers/${this.supplierId}/batch_orders`, this.query).then(response => {
        if (response.success && response.result !== null) {
          this.total = response.result.total
          this.query.current_page = response.result.current
          this.query.page_size = response.result.size
          const records = response.result.records || []
          records.forEach(e => {
            if (e.orderInfoList) {
              e.orderInfoList.forEach(o => {
                o.showAll = false
                o.readMore = false
              })
            }
          })
          this.dataList = records
          this.loading = false
        } else {
          this.loading = false
          this.$message.warning(response.message)
        }
      })
    },
    search() {
      this.query.page_size = 15
      this.query.current_page = 1
      this.loadData()
    },
    handleSizeChange(pageSize) {
      this.query.page_size = pageSize
      this.query.current_page = 1
      this.loadData()
    },
    handleCurrentChange(currentPage) {
      this.query.current_page = currentPage
      this.loadData()
    },
    handleDetail(no) {
      this.$router.push({
        path: 'refer-orders-detail',
        query: {no}
      })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-card__header {
  padding: 0;
}

.page_title {
  margin: 10px 30px 30px 0px !important;
}

.page-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: 1px solid #E1E1E1;
}

.search-box {
  height: 40px;
  width: 100%;
  display: flex;
  margin: 0px 0 20px 0;
}

.search-btn {
  height: 40px;
  background-color: #262b2f;
  border-color: #262b2f;
  min-width: 100px;
  border-radius: 0;
  color: #F7F7F7;
}

.create-btn {
  background-color: #262b2f;
  border-color: #262b2f;
  width: 120px;
  border-radius: 0;
  margin-left: 400px;
}

.refer-content {
  font-size: 14px;
  font-family: Graphik;
  min-height: calc(100vh - 400px);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 70px;

  .order {
    width: 100%;
    color: #262B2F;
    font-family: Graphik;
    font-size: 14px;
    margin-bottom: 20px;

    .black-weight {
      font-weight: 600;
      color: #262B2F !important;
    }

    &-header {
      height: 100px;
      background: #F7F7F7;
      padding: 20px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;

      .header-left {
        display: flex;
        flex-direction: row;

        .header-item {
          padding-right: 80px;

          &-title {
            font-weight: 600;
          }

          &-con {
            padding-top: 16px;
            color: #8f8f8f;
          }
        }
      }

    }

    /deep/ .el-card__body {
      padding: 0 20px;
    }

    &-content {
      color: #3E3E3E;
      font-family: Graphik;
      font-size: 14px;
      border-bottom: 1px #E1E1E1 solid;
      padding: 20px 0;

      .con-title-1 {
        .title-item {
          display: inline-block;
          padding-right: 90px;
        }
      }

      .con-title-2 {
        padding-top: 20px;
        color: #262B2F;
      }

      .con-images {
        width: 100%;
        padding: 10px 0;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;
        font-size: 16px;

        .img-item {
          border: #E1E1E1 1px solid;
          width: 100px;
          height: 100px;
          margin-right: 30px;
          margin-bottom: 30px;
          justify-content: space-evenly;

        }

        .more-btn {
          margin-bottom: 30px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
      }
    }
  }
}

.search_input {
  width: 35%;
  margin-left: 16px;
}

//.page_table {
//  background: #FFFFFF;
//  width: 100%;
//  position: fixed;
//  bottom: 0px;
//}

.text-btn {
  color: #3E3E3E;
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/pages/vidirect/refer-orders.vue